// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-btn[data-v-1edb32f7] {\n  font-size: 0.93rem !important;\n  padding: 0.8rem 2.8rem !important;\n  height: 100% !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
